// @flow

// Types
import type {
  ImportJobsPopupOperator,
} from '../types'

// Constants
import {
  MODEL,
  BRANCH,
} from 'hfty-model-import-jobs-popup'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: ImportJobsPopupOperator = composeOperator({
  model: MODEL,
  branch: BRANCH,
})

export default operator
